/**
 * ConfirmDialog — Modale de confirmation légère, réutilisable partout.
 *
 * Usage :
 *   const [confirm, setConfirm] = useState(null);
 *   <ConfirmDialog
 *     open={!!confirm}
 *     title="Supprimer le client ?"
 *     message="Cette action est irréversible."
 *     confirmLabel="Supprimer"
 *     danger
 *     onConfirm={() => { doDelete(); setConfirm(null); }}
 *     onCancel={() => setConfirm(null)}
 *   />
 */
export default function ConfirmDialog({ open, title, message, confirmLabel = 'Confirmer', danger = false, onConfirm, onCancel }) {
  if (!open) return null;

  return (
    <>
      <div
        onClick={onCancel}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 3000 }}
      />
      <div style={{
        position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
        background: '#1a1d2e', border: '1px solid #2a2d3e', borderRadius: 12,
        padding: 28, width: 380, maxWidth: '90vw', zIndex: 3001,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <h3 style={{ margin: '0 0 10px', color: '#e2e8f0', fontSize: 16, fontWeight: 700 }}>{title}</h3>
        {message && <p style={{ margin: '0 0 24px', color: '#94a3b8', fontSize: 13, lineHeight: 1.5 }}>{message}</p>}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{ padding: '9px 18px', borderRadius: 8, background: 'transparent', border: '1px solid #2a2d3e', color: '#94a3b8', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit' }}
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            style={{ padding: '9px 18px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', background: danger ? '#ef4444' : '#41B073', color: '#fff' }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </>
  );
}
